import { BrowserRouter,Routes,Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.scss';
import Home from "./pages/Home";
import About from "./pages/About";
import Skills from "./pages/Skills";
import  Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Works from "./pages/Works";

import './fonts/Space_Mono/stylesheet.css'



function App() {
  return <BrowserRouter>
             <Routes>
                 <Route path="/" element={<Home/>} />
                 <Route path="about" element={<About/>} />
                 <Route path="skills" element={<Skills/>} />
                 <Route path="works" element={<Works/>} />
                 <Route path="testimonials" element={<Testimonials/>} />
                 <Route path="contact" element={<Contact/>} />
             </Routes>
         </BrowserRouter>

 
  
}

export default App;
